import { Injectable } from '@angular/core'
import { Storage } from '@tokeet/tv3-platform'
import { AuthService } from '@tv3/services/auth.service'
import * as R from 'ramda'
import { PREFIX } from '@tv3/services/utils/storage-prefix'
import { IUserStorage } from '@tokeet-frontend/utility'

@Injectable({ providedIn: 'root' })
export class UserStorage extends Storage implements IUserStorage {
  constructor(private authService: AuthService) {
    super(localStorage, PREFIX)
  }

  get(key: string, defaultValue: any = null) {
    const userId = R.path(['id'], this.authService.user)
    if (R.isNil(userId)) {
      return defaultValue
    }
    const userKey = `${key}::${userId}`
    return super.get(userKey, defaultValue)
  }

  has(key: string) {
    const userId = R.path(['id'], this.authService.user)
    if (R.isNil(userId)) {
      return false
    }
    const userKey = `${key}::${userId}`
    return super.has(userKey)
  }

  set(key: string, value: any = null) {
    const userId = R.path(['id'], this.authService.user)
    if (!R.isNil(userId)) {
      const userKey = `${key}::${userId}`
      super.set(userKey, value)
    }
  }

  remove(key: string) {
    const userId = R.path(['id'], this.authService.user)
    const userKey = `${key}::${userId}`
    super.remove(userKey)
  }
}

@Injectable({ providedIn: 'root' })
export class SessionStorage extends Storage {
  constructor() {
    super(sessionStorage, PREFIX)
  }
}
